import React from 'react';
import fetchWrapper from './components/fetchWrapper';
import SideHeader from './components/common/sideHeader/sideHeader';
import ActivePageContainer from './pages/routingContainer';
import GlobalSearch from './components/common/globalSearch/GlobalSearch';

class App extends React.Component {
  state = {
    miniModeactive: false,
    mobileSideNavActive: false,
    globalSearchOpen: false,
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleGlobalShortcut);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleGlobalShortcut);
  }

  changeAppState = (newState) => {
    this.setState(newState);
  }

  handleGlobalShortcut = (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
      event.preventDefault();
      this.openGlobalSearch();
    }
  };

  openGlobalSearch = () => {
    this.setState({
      globalSearchOpen: true,
      mobileSideNavActive: false,
    });
  };

  closeGlobalSearch = () => {
    this.setState({ globalSearchOpen: false });
  };

  render() {
    // console.log(this.props)
    // const {
    //   user,
    //   fetchResource,
    //   modifyResource,
    //   history,
    //   location,

    // } = this.props;

    return (
      <div key="main-section" className={`main-section ${this.state.miniModeActive ? "mini" : ""}`}>
        <SideHeader
          miniModeActive={this.state.miniModeActive}
          mobileSideNavActive={this.state.mobileSideNavActive}
          changeAppState={this.changeAppState}
          onOpenGlobalSearch={this.openGlobalSearch}
          user={this.props.user}
          resources={this.props.resources}
        />
        <GlobalSearch
          isOpen={this.state.globalSearchOpen}
          onClose={this.closeGlobalSearch}
          user={this.props.user}
          resources={this.props.resources}
          history={this.props.history}
        />
        {/* <Loading
          fixed
          black
          size="40px"
        /> */}
        <ActivePageContainer
          mobileSideNavActive={this.state.mobileSideNavActive}
          changeAppState={this.changeAppState}
          loginNoticeBanner={this.props.loginNoticeBanner}
          {...this.state}
          {...this.props}
        />
      </div>
    );
  }
}



export default fetchWrapper(App);
